import { translate } from '../../Services/translation';

export const validateInputs = (quantityRef, lengthRef) => {
  if (!quantityRef || !lengthRef) {
    return true;
  }

  if (!quantityRef || !quantityRef.current || !lengthRef || !lengthRef.current) {
    return;
  }

  for (let i = 0; i < quantityRef.current.length; i++) {
    const quantityInput = quantityRef.current[i];
    const lengthInput = lengthRef.current[i];

    if (quantityInput && lengthInput) {
      quantityInput.setCustomValidity('');
      lengthInput.setCustomValidity('');

      if (quantityInput.value === '' || !quantityInput.checkValidity()) {
        quantityInput.setCustomValidity(translate('cutting.cuttinginformation.quantity.validation'));
        quantityInput.reportValidity();
        return false;
      }

      if (lengthInput.value === '' || !lengthInput.checkValidity()) {
        lengthInput.setCustomValidity(translate('cutting.cuttinginformation.length.validation'));
        lengthInput.reportValidity();
        return false;
      }
    }
  }
  return true;
};
